module.exports = __webpack_public_path__ + "static/media/feeltrip-logotype-black.e4ae5ccc.svg";